import React from "react";
import GeneralRichText from "components/Reusables/GeneralRichText";
import Media from "components/Reusables/Media";

export default function ArticleInclude(props) {
	const data = props.data;
	const type = data?.sys?.contentType?.sys?.id;
	const internalName = data?.fields?.internalName || data?.fields?.internalTitle;
	if (!type) {
		//this shouldn't run
		return <>Unknown Article Include</>;
	}
	data.fields.text = data.fields.includeText;
	const classes = data?.fields?.classes;

	if (!data) {
		return <div>ArticleInclude missing data</div>;
	}

	if (type === "table") {
		return <RenderedHtmlAsset data={data} />;
	} else if (type === "cta") {
		return <CtaAsset data={data} />;
	} else if (type === "articleInclude") {
		return <BasicArticleInclude data={data} />;
	} else {
		return <>Unknown Type: {type}</>;
	}
}

function BasicArticleInclude(props) {
	const data = props.data;
	const type = data?.sys?.contentType?.sys?.id;
	const internalName = data?.fields?.internalName;
	const classes = data?.fields?.classes;
	const align = data.fields.align ? "left" : "right";

	// return <>Basic Article Include</>;
	return (
		<div className={classes}>
			<GeneralRichText content={data.fields.includeText} />
		</div>
	);
}

function RenderedHtmlAsset(props) {
	const data = props.data;
	const type = data?.sys?.contentType?.sys?.id;
	const internalName = data?.fields?.internalName || data?.fields?.internalTitle;
	const html = data?.fields?.body;
	const classes = data.fields.classes;
	const float = classes?.includes("qa-q") || classes?.includes("qa-a") ? "none" : "left";

	return (
		<>
			<div dangerouslySetInnerHTML={{ __html: html }}></div>

			<style jsx>{`
				div {
					float: ${float};
					padding-right: 1em;
				}
			`}</style>
		</>
	);
}

function CtaAsset(props) {
	const data = props.data;
	const type = data?.sys?.contentType?.sys?.id;
	const internalName = data?.fields?.internalName || data?.fields?.internalTitle;

	if (!data) {
		return <>CTA Asset Missing Data</>;
	}
	data.fields.pathOrUrl = data.fields?.url;
	data.fields.media = data.fields?.image;

	return (
		<Media
			height={280}
			// extraClass="d-inline float-left "
			data={data}
		/>
	);
}
